import React from "react";

import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import MenueItem from "./menue-item"; 
import { BaseMenu } from './base-menu';

class TestMenu extends BaseMenu {
  constructor(props) {
    super(props, 'TEST_MENU');
  }

  render() {
    const { t } = this.props;
    const show = this.status.show;

    let menue = (
      <ul className="nav navbar-nav" onClick={this.toggleShow} onMouseOver={this.showMenu} >
        <li className="dropdown open">
          <a className="dropdown-toggle">Test</a>
            {show && (
              <ul className="dropdown-menu">
                <MenueItem title="medicationList" to="/medicationlist" />
                <MenueItem title="testpage" to="/testpage" />
                <MenueItem title="expandabletable" to="/expandabletable" />
                <MenueItem title="expandabletable2" to="/expandabletable2" />
              </ul>
            )}
        </li>
      </ul>
    );
    return menue;
  }
}

export default translate()(TestMenu);
